var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-box"},_vm._l((_vm.btns),function(btn,i){return _c(btn.component,{key:i,tag:"component",staticClass:"ad-btn",style:(btn.style),attrs:{"btn":btn,"page":_vm.page}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }